import { Observable } from "rxjs";

import { Provider } from "@angular/core";
import { UseCase } from "../../../../core/use-case";
import { Geo } from "../../../models/geo.model";
import { HrRepository } from "../../../repositories/hr.repository";

export class GetAllGeosUseCase implements UseCase<void, Geo[]> {
  constructor(private repo: HrRepository) {}
  execute(param: void): Observable<Geo[]> {
    return this.repo.getAllGeos();
  }
}

const getAllGeosUseCaseFactory = (repo: HrRepository) =>
  new GetAllGeosUseCase(repo);

export const getAllGeosUseCaseProvider: Provider = {
  provide: GetAllGeosUseCase,
  useFactory: getAllGeosUseCaseFactory,
  deps: [HrRepository],
};
